/**
 * Funciones selectoras y extractoras para borradores y guiones del proyecto.
 */

/**
 * Extrae un título descriptivo a partir del contenido del mensaje o guion.
 * Prioriza el primer encabezado Markdown (# ...) o la primera línea significativa.
 */
export function extractScriptTitle(content) {
  if (!content || typeof content !== "string") return "Borrador de guion";
  const lines = content.split("\n").map((l) => l.trim()).filter(Boolean);
  for (const line of lines) {
    if (line.startsWith("#")) {
      const clean = line.replace(/^#+\s*/, "").replace(/[*_~`]/g, "").trim();
      if (clean) return clean.slice(0, 80);
    }
    const titleMatch = line.match(/^(?:t[ií]tulo|guion)[:\s]+[«"']?([^»"'\n]+)[»"']?/i);
    if (titleMatch && titleMatch[1]) {
      return titleMatch[1].trim().slice(0, 80);
    }
  }
  const firstLine = (lines[0] || "").replace(/[*_~`]/g, "").trim();
  return firstLine ? firstLine.slice(0, 60) : "Borrador de guion";
}

/**
 * Determina con alta fiabilidad si un mensaje del asistente contiene un borrador o propuesta de guion.
 */
export function isLikelyScriptMessage(msg) {
  if (!msg || msg.role !== "assistant" || msg.system || msg.isError) return false;
  const content = (msg.content || "").toLowerCase();
  if (content.length < 50) return false;

  const scriptKeywords = [
    "guion",
    "script",
    "toma 1",
    "escena 1",
    "plano 1",
    "secuencia",
    "inicio:",
    "desarrollo:",
    "desenlace:",
    "acto 1",
    "tres ideas",
    "propuesta de guion",
    "ideas replanteadas",
  ];
  return scriptKeywords.some((kw) => content.includes(kw));
}
